import { MultiselectGroupOption } from '@dh-io-emh/ui/src/form/multiselectGroup/MultiselectGroup.model';
import { IProductFilterType } from '@dh-io-emh/shared/src/models/product-filter/product-filter.model';
import { FilterCode } from '@dh-io-emh/shared/src/models/product-filter/product-filter-base.model';
import ProductFilterMultiSelect, {
  IProductFilterMultiSelectOption,
} from '@dh-io-emh/shared/src/models/product-filter/product-filter-multi-select.model';

// Format integer product count to nice looking coma/dot separated string
export const formatProductCount = (
  locale: string,
  productCount?: number,
  thresholdCount?: number,
  thresholdTemplate?: string,
): string => {
  if (!productCount) {
    return '0';
  }

  // Format product count to the threshold template format:
  // E.g.: '2.034' -> '1.000+', where template is '{thresholdCount}+' and 'thresholdCount' is 1.000
  if (thresholdCount && thresholdTemplate && productCount > thresholdCount) {
    return thresholdTemplate.replace('{n}', thresholdCount.toLocaleString(locale));
  }

  // Return formated to string number in case of the missing template
  // E.g. 2034 -> '2.034'
  return productCount.toLocaleString(locale);
};

export const findFilterByCode = (filters: IProductFilterType[], filterCode: FilterCode) =>
  filters.find(({ code }) => code === filterCode);

export const mapMultiselectFilterOptions = ({
  filter,
  options,
}: {
  filter: ProductFilterMultiSelect;
  options: IProductFilterMultiSelectOption[];
}) =>
  options.map(({ count, name, value, disabled }: IProductFilterMultiSelectOption): MultiselectGroupOption => {
    const selected = filter.value.includes(value);

    return {
      // replace non-breaking spaces
      label: name.replace(/\u00A0/g, ' '),
      count,
      disabled: !selected && disabled,
      key: value,
      selected,
      value,
    };
  });
